// AppRouter.js
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../screens/Login";
import ProtectedRoute from "./ProtectedRoutes";
import DashBoard from "../screens/DashBoard";
import UserManagement from "../screens/UserManagement";
import BlogManagement from "../screens/BlogManagement";
import Dossier from "../screens/Dossier";
import Supplier from "../screens/Supplier";
import ContactManagement from "../screens/ContactManagement";
import DosserTermSheet from "../screens/DossierTermSheet";
import SupplierTermSheet from "../screens/SupplierTermSheet";
const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/login" element={<Login />} />

        {/* -------------------Admin Routes------------------------------------ */}
        <Route
          exact
          path="/admin"
          element={<ProtectedRoute allowedRoles={["admin"]} />}
        >
          {/* <Route exact path="/admin/data-form" element={<FillDetails />} /> */}
        </Route>

        <Route
          exact
          path="/"
          element={<ProtectedRoute allowedRoles={["seller", "admin"]} />}
        >
          <Route path="/dashboard" element={<DashBoard />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/blog-management" element={<BlogManagement />} />
          <Route path="/dossier-management" element={<Dossier />} />
          <Route path="/supplier-management" element={<Supplier />} />
          <Route path="/contact-management" element={<ContactManagement />} />
          <Route
            path="/dossier-termsheet-management"
            element={<DosserTermSheet />}
          />
          <Route
            path="/supplier-termsheet-management"
            element={<SupplierTermSheet />}
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;
